/* These lines of code are defining and exporting constants in JavaScript. */
export const FRAME_SIZE_REQUEST = 'FRAME_SIZE_REQUEST';
export const FRAME_SIZE_SUCCESS = 'FRAME_SIZE_SUCCESS';
export const FRAME_SIZE_FAILURE = 'FRAME_SIZE_FAILURE';
export const FRAME_SIZE_REMOVE = 'FRAME_SIZE_REMOVE';
